import { useSelector } from 'react-redux'
import useFetch from './fetch'


export function saveProfileAction(){
  return (dispatch, getState) => {
    const { resident, config, organization } = getState()
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}.json`,
      method: 'PATCH',
      data: { resident }
    }).then(()=>{
      if (config.isStaffApp) alert('Changes saved successfully.')
      return ({ type: 'SAVED_CLIENT_PROFILE' })
    })
  }
}

export function useSaveChanges(){
  const [ saving, setSaving ] = React.useState(false)
  const { resident, config, organization } = useSelector(state=>state)
  const fetch = useFetch()

  function saveChanges() {
    setSaving(true)
    fetch(`/organizations/${organization.name}/residents/${resident.id}.json`, {
      method: "PATCH",
      data: { resident }
    }).then((data) => {
      setSaving(false)
      if (config.isStaffApp) alert('Changes successfully saved.')
    });
  }

  return { saveChanges, saving }
}